import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface ModuleConfig {
    showIframe: boolean;
    enableToggle: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModuleConfigService {
    private _config: Record<string, ModuleConfig> = {};

    constructor(private http: HttpClient) {}

    get config(): Record<string, ModuleConfig> {
        return this._config;
    }

    async load(): Promise<void> {
        try {
            // Always fetch the freshest config from the network. The service
            // worker serves this file via a "freshness" data group and the
            // no-cache header bypasses the browser HTTP cache, so a changed
            // config takes effect on the next load without users having to
            // manually clear their cache.
            this._config = await firstValueFrom(
                this.http.get<Record<string, ModuleConfig>>(
                    'assets/module-config.json',
                    {
                        headers: { 'Cache-Control': 'no-cache' },
                    }
                )
            );
        } catch {
            // Don't block app startup if the config can't be loaded (e.g.
            // offline before the service worker has cached a copy).
            this._config = {};
        }
    }

    getConfig(moduleId: string): ModuleConfig | undefined {
        return this._config[moduleId];
    }
}
